export const MIXPANEL_EVENTS = {
  USER_LOGIN: 'user_login',
  USER_INVITED_TO_PROJECT: 'user_invited_to_project',
  USER_CREATED_ACCOUNT: 'user_created_account',
  USER_FORGOT_PASSWORD: 'user_forgot_password',
  USER_UPDATED_PROFILE: 'user_updated_profile',
  USER_UPDATED_RULE_STATUS: 'user_updated_rule_status',
  USER_CREATED_NEW_RULE: 'user_created_new_rule',
  USER_UPDATED_RULE: 'user_updated_rule',
  USER_DELETED_RULE: 'user_deleted_rule',
  USER_UPDATED_BOT_SETTINGS: 'user_updated_bot_settings',
  USER_INTEGRATED_HUBSPOT: 'user_integrated_hubspot',
  USER_INTEGRATED_MARKETO: 'user_integrated_marketo',
  USER_ADDED_TEAM_MEMBER: 'user_added_team_member',
  USER_REMOVED_TEAM_MEMBER: 'user_removed_team_member',
  USER_CREATED_BOT_CONVERSATION: 'user_created_bot_conversation',
  USER_UPDATED_BOT_CONVERSATION_STATUS: 'user_updated_bot_conversation_status',
  USER_DELETED_BOT_CONVERSATION: 'user_deleted_bot_conversation',
  USER_CLONED_BOT_CONVERSATION: 'user_cloned_bot_conversation',
  USER_SAVED_BOT_CONVERSATION: 'user_saved_bot_conversation',
  USER_SELECTED_INBOX_USER_CONVERSATION_TAB: 'user_selected_inbox_user_conversation_tab',
  USER_SELECTED_INBOX_BOT_CONVERSATION_TAB: 'user_selected_inbox_bot_conversation_tab',
  USER_SELECTED_CONVERSATION_FILTER: 'user_selected_conversation_filter',
  USER_SET_CUSTOM_CONVERSATION_FILTER: 'user_set_custom_conversation_filter',
  USER_UPDATED_AVAILABLE_STATUS: 'user_updated_available_status',
  USER_SET_CONVERSATION_STATUS_OPEN: 'user_set_conversation_status_open',
  USER_SET_CONVERSATION_STATUS_CLOSED: 'user_set_conversation_status_closed',
  USER_SET_CONVERSATION_STATUS_PENDING: 'user_set_conversation_status_pending',
  USER_ARCHIVED_CONVERSATION: 'user_archived_conversation',
  USER_STARRED_CONVERSATION: 'user_starred_conversation',
  USER_SELECTED_BOOK_A_MEETING: 'user_selected_book_a_meeting',
  USER_RECEIVED_CONVERSATION_REQUEST: 'user_received_conversation_request',
  USER_ACCEPTED_CONVERSATION_REQUEST: 'user_accepted_conversation_request',
  USER_DENIED_CONVERSATION_REQUEST: 'user_denied_conversation_request',
  USER_CONVERSATION_REQUEST_TIMEOUT: 'user_conversation_request_timeout',
  USER_JOIN_CONVERSATION: 'user_join_conversation',
  USER_LEAVE_CONVERSATION: 'user_leave_conversation',
  USER_ADDED_PARTICIPANT_TO_CONVERSATION: 'user_added_participant_to_conversation',
  USER_REMOVED_PARTICIPANT_FROM_CONVERSATION: 'user_removed_participant_from_conversation',
  USER_OPENED_ABV: 'user_opened_abv',
  USER_OPENED_ABV_PERSON_TAB: 'user_opened_abv_person_tab',
  USER_OPENED_ABV_ACCOUNT_TAB: 'user_opened_abv_account_tab',
  USER_CHANGED_ANALYTICS_DURATION: 'user_changed_analytics_duration',
  USER_SET_ANALYTICS_TABLE_FILTER: 'user_set_analytics_table_filter',
  USER_VISITED_PROFILE_PAGE: 'user_visited_profile_page',
  USER_VISITED_ANALYTICS_PAGE: 'user_visited_analytics_page',
  USER_VISITED_CONFIGURATIONS_PAGE: 'user_visited_configurations_page',
  USER_VISITED_INTEGRATIONS_PAGE: 'user_visited_integrations_page',
  USER_VISITED_TEAM_PAGE: 'user_visited_team_page',
  USER_VISITED_CONVERSATIONS_PAGE: 'user_visited_conversations_page',
  USER_VISITED_INBOX_PAGE: 'user_visited_inbox_page',
  USER_LOGOUT: 'user_logout',
};
